export default __webpack_public_path__ + "static/media/month.37fbc906.png";